export enum EnvironmentName {
  test = 'test',
  uat = 'uat',
  hotfix = 'hotfix',
  prod = 'prod',
}
